import * as angular from 'angular';
import * as _ from 'lodash';

import { GroupChangeBase } from '../groupChangeBase';
import { guidEmpty } from '../../../common';
import { State, FlatGroup, ComponentDefinition } from '../../../models';
import { IStateService } from '../../../services';

interface GroupStateView {
    guid: string;
    groupName: string;
    templateName: string;
    depth: number;
    isDifferent: boolean;
    changeGuid: string;
    change: any;
    states: StateView[];
}

interface StateView {
    groupName: string;
    templateName: string;
    missGroup: boolean;
    missTemplate: boolean;
    change: any;
    changeGuid: string;
}

class GroupChangesStates extends GroupChangeBase implements angular.IComponentController {
    static controllerId = 'GroupChangesStates';

    isLoading: boolean;
    display: GroupStateView[];
    states: State[];

    private _missing: string;

    static $inject = ['stateService', '$translate'];

    constructor(private _stateService: IStateService,
        private _$translate: angular.translate.ITranslateService) {
        super();
    }

    $onInit() {
        this._missing = this._$translate.instant('missing state');
        if (this.master) {
            this.applyAllFromGroup = this.applyAllFromGroup.bind(this);
            this.applyAllFromTemplate = this.applyAllFromTemplate.bind(this);
            this.ignoreAll = this.ignoreAll.bind(this);
            this.share.diff.applyAllFromTemplate = this.applyAllFromTemplate;
            this.share.diff.applyAllFromGroup = this.applyAllFromGroup;
            this.share.diff.ignoreAll = this.ignoreAll;
        }
        this.refresh();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['groups'] || changesObj['templates'] || changesObj['changes']) {
            this.refresh();
        }
    }

    private refresh() {
        this.isLoading = true;

        this._stateService.getAll()
            .then(data => {
                this.states = data.map(d => d.state);
                this.display = [];
                if (this.groups && this.templates && this.changes) {
                    this.isLoading = true;
                    this.groups.forEach(group => {
                        const template = _.find(this.templates, t => group.templateGuid === t.guid);
                        if (template) {
                            this.display.push(this.buildViewGroup(group, template));
                        }
                    });
                    this.createAlignButtons();

                }
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    private createAlignButtons() {
        const self = this;
        this.share.central = [];

        this.display.forEach(g => {

            this.share.central.push({});
            g.states.forEach(s => {
                const toAdd = {
                    leftAction: s.missTemplate && s.changeGuid
                        ? () => self.share.diff.applyFromGroup(s.change)
                        : undefined,
                    leftSelected: () => self.share.selectedDiff.fromGroup[s.change.guid],
                    ignoreAction: () => self.share.diff.ignore(s.change),
                    ignoreSelected: () => self.share.selectedDiff.ignores[s.change.guid],
                    rightAction: s.missGroup && s.changeGuid
                        ? () => self.share.diff.applyFromTemplate(s.change)
                        : undefined,
                    rightSelected: () => self.share.selectedDiff.fromTemplate[s.change.guid]
                };

                this.share.central.push(toAdd);
            });
        });
    }

    private buildViewGroup(group: FlatGroup, template: FlatGroup): GroupStateView {
        const view = {
            guid: group.guid,
            groupName: group.name,
            templateName: template.name,
            depth: (<any>group).depth,
            isDifferent: false,
            changeGuid: guidEmpty,
            change: undefined,
            states: this.buildViewState(group, template)
        };

        return view;
    }

    private buildViewState(group: FlatGroup, template: FlatGroup): StateView[] {
        const result: StateView[] = [];

        const changes = this.changes.filter(c => true);

        group.groupStateCollection
            .forEach(state => {
                const ref = _.find(this.states, s => s.guid === state.stateGuid);
                const idx = _.findIndex(changes, c => c.objectGuid === state.stateGuid &&
                    c.differenceCollection[0].ownerGuid === group.guid);

                if (idx > -1) {
                    const change = (<any>changes.splice(idx, 1)[0]).differenceCollection[0];
                    const sv: StateView = {
                        groupName: ref?.name,
                        templateName: this._missing,
                        missGroup: false,
                        missTemplate: true,
                        change: change,
                        changeGuid: change.guid
                    };

                    result.push(sv);
                }
            });

        // fill the missing from template
        changes.forEach(c => {
            const change = c.differenceCollection[0];
            if (change.ownerGuid === group.guid) {
                const ref = _.find(this.states, s => s.guid === c.objectGuid);
                const sv: StateView = {
                    groupName: this._missing,
                    templateName: ref.name,
                    missGroup: true,
                    missTemplate: false,
                    change: change,
                    changeGuid: change.guid
                };
                result.push(sv);
            }
        });

        return result;
    }


    private applyAllFromTemplate() {
        this.share.central.filter(c => c.rightAction && !this.isTreated(c.changeGuid))
            .forEach(c => c.rightAction());
    }

    private applyAllFromGroup() {
        this.share.central.filter(c => c.leftAction && !this.isTreated(c.changeGuid))
            .forEach(c => c.leftAction());
    }

    private ignoreAll() {
        this.share.central.filter(c => c.ignoreAction && !this.isTreated(c.changeGuid))
            .forEach(c => c.ignoreAction());
    }
}

export const wtGroupChangesStatesWidget: ComponentDefinition = {
    componentId: 'wtGroupChangesStates',
    controller: GroupChangesStates,
    controllerAs: 'vm',
    template: require('./groupChangesStates.component.html'),
    bindings: {
        changes: '<',
        groups: '<',
        templates: '<',
        master: '=?',
        share: '='
    }
};